import { Component } from '@angular/core';

@Component({
  selector: 'hunch-app-empty-route',
  template: '',
})
export class EmptyRouteComponent {}
